import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Handshake, CheckCircle2, Briefcase, Users, Shield, TrendingUp, Building2, Home } from 'lucide-react';
export function PartnerPage() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    // Logic to send email would go here
  };
  if (submitted) {
    return <Layout data-id="element-1354">
        <div className="min-h-[60vh] flex items-center justify-center bg-gray-50 px-4" data-id="element-1355">
          <Card className="max-w-md w-full text-center p-8" data-id="element-1356">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1357">
              <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-1358" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1359">
              Demande reçue !
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-1360">
              Merci de votre intérêt pour un partenariat avec l'ADCC. Nous avons
              bien reçu vos informations et vous avez envoyé un email de
              confirmation. Notre équipe vous recontactera très prochainement
              pour discuter des opportunités de collaboration et de recrutement.
            </p>
            <Button onClick={() => window.location.href = '/'} variant="outline" data-id="element-1361">
              Retour à l'accueil
            </Button>
          </Card>
        </div>
      </Layout>;
  }
  return <Layout data-id="element-1362">
      <SEO {...pageSEO.partner} data-id="element-1363" />
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-1364">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1365">
          <h1 className="text-4xl font-bold mb-4" data-id="element-1366">Devenir Partenaire</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-1367">
            Rejoignez notre réseau d'employeurs partenaires et recrutez des
            personnels qualifiés, formés et accompagnés par l'ADCC dans un cadre
            éthique et transparent.
          </p>
        </div>
      </div>

      {/* Types de Partenaires */}
      <section className="py-16 bg-white" data-id="element-1368">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1369">
          <div className="text-center mb-12" data-id="element-1370">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1371">
              Qui peut devenir partenaire ?
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1372">
              L'ADCC collabore avec différents types d'employeurs pour faciliter
              l'insertion professionnelle digne et durable.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1373">
            {[{
            icon: Home,
            title: 'Familles',
            desc: 'Recrutez du personnel de maison qualifié pour votre foyer',
            examples: "Aide ménagère, garde d'enfants, cuisinière"
          }, {
            icon: Building2,
            title: 'Entreprises',
            desc: "Trouvez des personnels d'entretien et de services pour vos locaux",
            examples: "Agents d'entretien, maintenance, services généraux"
          }, {
            icon: Users,
            title: 'Institutions',
            desc: "Collaborez pour des programmes d'insertion professionnelle",
            examples: 'ONG, associations, structures publiques'
          }].map((type, index) => <Card key={index} className="text-center border-t-4 border-t-[#1E88E5]" data-id="element-1374">
                <CardContent className="pt-8 pb-6" data-id="element-1375">
                  <div className="inline-flex items-center justify-center p-4 bg-blue-50 rounded-full mb-4" data-id="element-1376">
                    <type.icon className="w-8 h-8 text-[#1E88E5]" data-id="element-1377" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1378">
                    {type.title}
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-1379">{type.desc}</p>
                  <p className="text-sm text-gray-500 italic" data-id="element-1380">
                    {type.examples}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Avantages du Partenariat */}
      <section className="py-20 bg-gray-50" data-id="element-1381">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1382">
          <div className="text-center mb-12" data-id="element-1383">
            <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-1384">
              Pourquoi Recruter via l'ADCC
            </span>
            <h2 className="text-3xl font-bold text-gray-900 mt-2 mb-4" data-id="element-1385">
              Les avantages d'un partenariat avec l'ADCC
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1386">
              Des compétences reconnues, des emplois dignes, un accompagnement
              sur mesure.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1387">
            {[{
            icon: Briefcase,
            title: 'Personnels Qualifiés et Certifiés',
            desc: 'Accédez à des profils formés professionnellement avec certification reconnue. Compétences techniques et relationnelles validées.'
          }, {
            icon: Shield,
            title: 'Cadre Éthique et Transparent',
            desc: "Recrutement dans le respect des droits, conditions claires, contrats formalisés. Sensibilisation aux bonnes pratiques d'emploi."
          }, {
            icon: Users,
            title: 'Accompagnement Personnalisé',
            desc: 'Matching précis selon vos besoins, préparation du personnel avant placement, intégration facilitée.'
          }, {
            icon: TrendingUp,
            title: 'Suivi Post-Placement',
            desc: 'Accompagnement continu après recrutement, médiation en cas de besoin, garantie de durabilité de la relation professionnelle.'
          }].map((benefit, index) => <Card key={index} className="bg-white" data-id="element-1388">
                <CardContent className="p-6" data-id="element-1389">
                  <div className="flex items-start gap-4" data-id="element-1390">
                    <div className="flex-shrink-0 p-3 bg-blue-50 rounded-lg" data-id="element-1391">
                      <benefit.icon className="w-6 h-6 text-[#1E88E5]" data-id="element-1392" />
                    </div>
                    <div data-id="element-1393">
                      <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1394">
                        {benefit.title}
                      </h3>
                      <p className="text-gray-600 text-sm" data-id="element-1395">{benefit.desc}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Notre Engagement */}
      <section className="py-20 bg-white" data-id="element-1396">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1397">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1398">
            <div data-id="element-1399">
              <span className="text-[#1E88E5] font-semibold tracking-wide uppercase text-sm" data-id="element-1400">
                Notre Engagement Envers Vous
              </span>
              <h2 className="text-3xl font-bold text-gray-900 mt-2 mb-6" data-id="element-1401">
                Un placement responsable et structuré
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-1402">
                L'ADCC s'engage à créer un cadre structuré, sécurisé et
                respectueux pour l'emploi des personnels de maison et de
                services.
              </p>

              <div className="space-y-4" data-id="element-1403">
                {['Identification et préparation des profils selon vos besoins', 'Mise en relation transparente avec conditions claires', "Sensibilisation aux bonnes pratiques d'emploi", 'Suivi post-placement et médiation si nécessaire', 'Garantie de respect des droits et de la dignité'].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-1404">
                    <CheckCircle2 className="w-6 h-6 text-[#1E88E5] flex-shrink-0 mt-0.5" data-id="element-1405" />
                    <span className="text-gray-700" data-id="element-1406">{item}</span>
                  </div>)}
              </div>
            </div>

            <div className="relative" data-id="element-1407">
              <img src="https://cdn.magicpatterns.com/uploads/jfY9WFQQPLNmCKBmbcpuEW/Femmes_Menage_Emploi_3.png" alt="Personnels formés et certifiés ADCC" className="rounded-2xl shadow-xl w-full" data-id="element-1408" />
              <div className="absolute -bottom-6 -right-6 bg-[#1E88E5] text-white p-6 rounded-lg shadow-lg max-w-xs hidden md:block" data-id="element-1409">
                <p className="font-bold text-lg mb-2" data-id="element-1410">
                  "Former sans débouché n'est pas suffisant."
                </p>
                <p className="text-sm text-blue-100" data-id="element-1411">
                  Notre engagement : transformer les compétences en opportunités
                  d'emploi.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Processus de Partenariat */}
      <section className="py-20 bg-gray-50" data-id="element-1412">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1413">
          <div className="text-center mb-12" data-id="element-1414">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-1415">
              Comment ça marche ?
            </h2>
            <p className="text-lg text-gray-600" data-id="element-1416">
              Un processus simple et transparent en 4 étapes
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-1417">
            {[{
            step: '1',
            title: 'Contactez-nous',
            desc: 'Remplissez le formulaire ci-dessous avec vos besoins'
          }, {
            step: '2',
            title: 'Échange',
            desc: 'Notre équipe vous contacte pour comprendre vos attentes'
          }, {
            step: '3',
            title: 'Matching',
            desc: 'Nous identifions les profils correspondant à vos critères'
          }, {
            step: '4',
            title: 'Placement & Suivi',
            desc: 'Mise en relation, intégration et accompagnement continu'
          }].map((step, index) => <div key={index} className="text-center" data-id="element-1418">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#1E88E5] text-white rounded-full text-2xl font-bold mb-4" data-id="element-1419">
                  {step.step}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1420">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1421">{step.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Formulaire */}
      <section className="py-20 bg-white" data-id="element-1422">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1423">
          <Card data-id="element-1424">
            <CardContent className="p-8" data-id="element-1425">
              <div className="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100" data-id="element-1426">
                <div className="p-3 bg-blue-50 rounded-full" data-id="element-1427">
                  <Handshake className="w-8 h-8 text-[#1E88E5]" data-id="element-1428" />
                </div>
                <div data-id="element-1429">
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-1430">
                    Formulaire de partenariat
                  </h2>
                  <p className="text-gray-500 text-sm" data-id="element-1431">
                    Devenez employeur partenaire et recrutez des personnels
                    qualifiés
                  </p>
                </div>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1432">
                <div data-id="element-1433">
                  <label htmlFor="partnerType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1434">
                    Type de partenaire *
                  </label>
                  <select id="partnerType" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border bg-white" data-id="element-1435">
                    <option value="" data-id="element-1436">Sélectionnez...</option>
                    <option value="famille" data-id="element-1437">Famille (particulier)</option>
                    <option value="entreprise" data-id="element-1438">Entreprise</option>
                    <option value="institution" data-id="element-1439">Institution / ONG</option>
                  </select>
                </div>

                <div data-id="element-1440">
                  <label htmlFor="orgName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1441">
                    Nom de l'entreprise / organisation (si applicable)
                  </label>
                  <input type="text" id="orgName" className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" data-id="element-1442" />
                </div>

                <div data-id="element-1443">
                  <label htmlFor="responsibleName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1444">
                    Nom complet du contact *
                  </label>
                  <input type="text" id="responsibleName" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" data-id="element-1445" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1446">
                  <div data-id="element-1447">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1448">
                      Email *
                    </label>
                    <input type="email" id="email" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" data-id="element-1449" />
                  </div>
                  <div data-id="element-1450">
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1451">
                      Numéro de téléphone *
                    </label>
                    <input type="tel" id="phone" required className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" data-id="element-1452" />
                  </div>
                </div>

                <div data-id="element-1453">
                  <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1454">
                    Adresse / Localisation *
                  </label>
                  <textarea id="address" required rows={2} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" data-id="element-1455"></textarea>
                </div>

                <div data-id="element-1456">
                  <label htmlFor="needs" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1457">
                    Vos besoins en recrutement *
                  </label>
                  <textarea id="needs" required rows={4} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="Décrivez le type de personnel recherché, les compétences requises, le nombre de postes, etc." data-id="element-1458"></textarea>
                </div>

                <div data-id="element-1459">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1460">
                    Message complémentaire (optionnel)
                  </label>
                  <textarea id="message" rows={3} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border" placeholder="Informations supplémentaires..." data-id="element-1461"></textarea>
                </div>

                <div className="pt-4" data-id="element-1462">
                  <Button type="submit" className="w-full" size="lg" data-id="element-1463">
                    Envoyer la demande de partenariat
                  </Button>
                  <p className="text-xs text-gray-500 text-center mt-4" data-id="element-1464">
                    En soumettant ce formulaire, vous acceptez que nous
                    traitions vos données pour vous recontacter et faciliter le
                    processus de recrutement.
                  </p>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      </section>
    </Layout>;
}